import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Inject } from "vue-property-decorator";
let MutilText = class MutilText extends Vue {
    constructor() {
        super(...arguments);
        this.showAll = true;
        this.collapsed = false;
    }
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    scroll() {
        const el = this.$el;
        this.showAll = !(el.scrollHeight > el.offsetHeight + 3) && (el.scrollHeight > 74);
        // console.log('rich-text',el.scrollHeight,el.offsetHeight);
        if (el.offsetHeight === 0) {
            clearTimeout(this.taskRef);
            this.taskRef = setTimeout(() => {
                this.scroll();
            }, 500);
        }
    }
    toggle() {
        this.collapsed = !this.collapsed;
    }
    mounted() {
        this.$nextTick(() => {
            this.scroll();
        });
    }
    destroyed() {
        clearTimeout(this.taskRef);
    }
};
tslib_1.__decorate([
    Prop({
        default: ""
    })
], MutilText.prototype, "text", void 0);
tslib_1.__decorate([
    Prop({
        default: "left"
    })
], MutilText.prototype, "align", void 0);
tslib_1.__decorate([
    Prop({
        default: ''
    })
], MutilText.prototype, "labelStyle", void 0);
tslib_1.__decorate([
    Inject()
], MutilText.prototype, "layoutTypeFn", void 0);
MutilText = tslib_1.__decorate([
    Component({
        name: "rich-text"
    })
], MutilText);
export default MutilText;
